import {
	SELECT_COMMENT_TYPE, SHOW_MORE_COMMENTS, UPDATE_MEDIA_DESCRIPTION_VISIBLITY, UPDATE_DOWNLOAD_MENU_VISIBLITY,
	START_SCRUB, UPDATE_SCRUB, FINISH_SCRUB, SHOW_SCRUBBER, GO_TO_COMMENT, FINISH_GO_TO_COMMENT,
	ADD_ERROR, ADD_ERRORS, REMOVE_ERROR, CLEAR_ERRORS,
	START_LOADING, FINISH_LOADING,
	START_COMMENT, START_EDITING_COMMENT, START_COMMENT_REPLY, STOP_EDITING_COMMENT, UPDATE_COMMENT_FIELD,
	UPDATE_CREATE_FORM, CLEAR_CREATE_FORM,
	SHOW_COMMENT_MENU, HIDE_COMMENT_MENU,
	UPDATE_POSITION
} from "../reducers/actiontypes";
import { formatTimestamp } from "../util";

const initialState = (function(state={}) {
	state.comment_type = state.comment_type || "";
	state.visible_comments = state.visible_comments || 10;
	state.errors = state.errors || [];
	state.loading = state.loading || false;
	state.show_media_description = state.show_media_description || "checksize";
	state.show_download_menu = state.show_download_menu || false;
	state.debug = state.debug === true || state.debug === "1" || false;
	state.iframe = state.iframe || false;
	state.show_scrubber = state.show_scrubber || true;
	state.create_form = {
		body: "",
		timestamp: "0:00:00",
		bTimelineComment: false,
		timestamp_editable: true
	};
	state.highlighted_comment = "";
	state.scroll_to_comment = false;
	return state;
})(window.commentstate.ui);

export default function(state=initialState, action) {
	switch (action.type) {
		case SELECT_COMMENT_TYPE:
			return { ...state, comment_type: action.comment_type, visible_comments: 10 };
		case SHOW_MORE_COMMENTS:
			return { ...state, visible_comments: state.visible_comments+10 };
		case CLEAR_ERRORS:
			return { ...state, errors: [] };
		case ADD_ERROR:
			if (state === null)
				return { ...state, errors: [action.message] };
			else
				return { ...state, errors: [...state.errors, action.message] };
		case ADD_ERRORS:
			if (state === null)
				return { ...state, errors: action.messages };
			else
				return { ...state, errors: [...state.errors, ...action.messages] };
		case REMOVE_ERROR:
			return { ...state, errors: state.errors.splice(action.index, 1) };
		case START_LOADING:
			return { ...state, loading: false };
		case FINISH_LOADING:
			return { ...state, loading: false };
		case UPDATE_MEDIA_DESCRIPTION_VISIBLITY:
			return { ...state, show_media_description: action.visible };
		case UPDATE_DOWNLOAD_MENU_VISIBLITY:
			return { ...state, show_download_menu: action.visible };
		case START_COMMENT:
			return { ...state, dialog: {
				using_dialog: true,
				dialog_title: "Add Comment",
				body: "",
				bTimelineComment: action.bTimelineComment,
				timestamp: action.timestamp,
				timestamp_editable: action.timestamp_editable,
				comment_type: action.comment_type,
				was_playing: action.was_playing
			}};
		case START_EDITING_COMMENT:
			return { ...state, dialog: {
				using_dialog: true,
				dialog_title: "Edit Comment",
				index: action.index,
				body: action.body,
				bTimelineComment: action.bTimelineComment,
				timestamp: action.timestamp,
				timestamp_editable : action.timestamp_editable,
				comment_type : action.comment_type
			}};
		case START_COMMENT_REPLY:
			return { ...state, dialog: {
				using_dialog: true,
				dialog_title: "Reply",
				reply_to_index: action.reply_to_index,
				parent_index: action.parent_index,
				body: "",
				bTimelineComment: action.bTimelineComment,
				timestamp: action.timestamp,
				timestamp_editable: false,
				comment_type: action.comment_type,
				was_playing: action.was_playing
			}};
		case UPDATE_COMMENT_FIELD:
			return { ...state, dialog: { ...state.dialog, [action.field]: action.value } };
		case UPDATE_CREATE_FORM:
			return { ...state, create_form: { ...state.create_form, [action.field]: action.value } };
		case UPDATE_POSITION:
			return { ...state, create_form: { ...state.create_form, timestamp: formatTimestamp(action.position) } };
		case CLEAR_CREATE_FORM:
			return { ...state, create_form: {
				body: "",
				timestamp: "0:00:00",
				bTimelineComment: false,
				timestamp_editable: true
			} };
		case STOP_EDITING_COMMENT:
			state = { ...state };
			delete state.dialog;
			return state;
		case START_SCRUB:
			return { ...state, scrub: { x:action.x, total_width:action.total_width } };
		case UPDATE_SCRUB:
			if (state.scrub === undefined)
				return state;
			
			return { ...state, scrub: { x:action.x, total_width:action.total_width } };
		case FINISH_SCRUB:
			if (state.scrub === undefined)
				return state;

			state = { ...state };
			delete state.scrub;
			return state;
		case SHOW_SCRUBBER:
			return { ...state, show_scrubber: action.visible };
		case GO_TO_COMMENT:
			return { ...state, highlighted_comment: action.highlighted_comment, scroll_to_comment: true, comment_type: action.comment_type, visible_comments: action.visible_comments };
		case FINISH_GO_TO_COMMENT:
			return { ...state, scroll_to_comment: false };
		case SHOW_COMMENT_MENU:
			return { ...state, show_comment_menu: action.objectid };
		case HIDE_COMMENT_MENU:
			state = { ...state };
			delete state.show_comment_menu;
			return state;
		default:
			return state;
	}
}
